import React from 'react';
import {
  Table as MuiTable,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TableContainer,
  TablePagination,
  Paper,
} from '@mui/material';
import { acmeCardSx, acmeTableSx } from '../../theme/acmeTheme';
import { mergeSx } from './utils/mergeSx';

export function Table({ children, sx, containerSx }) {
  return (
    <TableContainer component={Paper} elevation={0} sx={mergeSx(acmeCardSx, containerSx)}>
      <MuiTable sx={mergeSx(acmeTableSx, sx)}>{children}</MuiTable>
    </TableContainer>
  );
}

Table.Head = TableHead;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Cell = TableCell;
Table.Footer = TableFooter;
Table.Pagination = TablePagination;

export default Table;
